export function base64urlToBuffer(base64url: string): ArrayBuffer {
  const pad = base64url.length % 4 === 0 ? '' : '='.repeat(4 - (base64url.length % 4));
  const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/') + pad;
  const str = atob(base64);
  const bytes = new Uint8Array(str.length);
  for (let i = 0; i < str.length; i++) bytes[i] = str.charCodeAt(i);
  return bytes.buffer;
}

export function bufferToBase64url(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let str = '';
  for (let i = 0; i < bytes.byteLength; i++) str += String.fromCharCode(bytes[i]);
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

export async function sha256(data: ArrayBuffer | string): Promise<string> {
  const enc = typeof data === 'string' ? new TextEncoder().encode(data) : new Uint8Array(data);
  const digest = await crypto.subtle.digest('SHA-256', enc);
  return bufferToBase64url(digest);
}

export async function verifyP256Signature(spkiBase64url: string, data: ArrayBuffer | string, signatureBase64url: string): Promise<boolean> {
  try {
    const spki = base64urlToBuffer(spkiBase64url);
    const key = await crypto.subtle.importKey(
      'spki',
      spki,
      { name: 'ECDSA', namedCurve: 'P-256' },
      false,
      ['verify']
    );
    const enc = typeof data === 'string' ? new TextEncoder().encode(data) : new Uint8Array(data);
    const sig = new Uint8Array(base64urlToBuffer(signatureBase64url));
    return await crypto.subtle.verify({ name: 'ECDSA', hash: 'SHA-256' }, key, sig, enc);
  } catch {
    return false;
  }
}


